import { useContext } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const OnboardingSalesProduct = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	
	const hasReceivedProduct = startHere.data.tasks?.received_orders?.has_data

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, onboardingSalesProduct: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}
	
	const steps = [
		{
			target: '.onboardingSalesProductFirstStep',
			title: "Orders Category",
			content: 'Manage orders based on their status.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.onboardingSalesProductSecondStep',
			title: "Search Orders",
			content: 'You can search up specific order.',
			disableBeacon: true,
			placement: "bottom",
		},
		...hasReceivedProduct ? [
			{
				target: '.productReceivedFirstStep',
				title: "View Order",
				content: 'Click to view order details.',
				disableBeacon: true,
				placement: "left",
			},
			{
				target: '.productReceivedSecondStep',
				title: "Update Order",
				content: 'Click to update the status of this order.',
				disableBeacon: true,
				placement: "left",
			},
			{
				target: '.productReceivedThirdStep',
				title: "Move to Preparing",
				content: 'Put the ordering in preparing status.',
				disableBeacon: true,
				placement: "top",
				modalTriggers: 'productSalesModal'
			},
		] : []
	]

	return (
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.onboardingSalesProduct)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="onboardingSalesProduct" 
			featureName="sales"
			disableScrolling={true}
		/>
	);
}
